/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { css } from '@emotion/react';

import CommonSelect from '../common/Select';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';

import { useUserActions } from '../../actions/UserActions';
import { useClientLanguages } from '../../utils/hooks';

import Text from '@mui/material/Typography';

export default function Step0({ user }) {
  const clientLanguages = useClientLanguages();
  const [language, setLanguage] = useState(
    user?.language || i18n.language?.split('-')?.[0] || 'sv'
  );
  const { t } = useTranslation();
  const { updateUserAsync } = useUserActions();

  async function handleLanguageChange(event) {
    setLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
    await updateUserAsync({ language: event.target.value });
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <Text variant="h6">{t('Välkommen till Klang.ai!')}</Text>
      <Text variant="subtitle1" color="textSecondary">
        {t('Välj ditt språk för att komma igång.')}
      </Text>
      <CommonSelect
        css={css`
          margin-top: 1rem;
        `}
        label={t('Språk')}
        value={language}
        onChange={handleLanguageChange}
        options={clientLanguages}
        size="small"
      />
    </div>
  );
}
